import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { fetchAppToken } from '../actions/app_token'
import { getTranslations } from '../actions/language'
import { toolTipManager } from '../services/instanceService';
import { LOGIN_TOOL_TIP_ID, RESET_PASSWORD_TOOL_TIP_ID } from '../constants';

import Toastr from '../components/toastr';
import SystemHeader from '../components/system_header'
import ToolTip from '../components/tool_tip/tool_tip';

import '../App.css';

class Login extends Component {
  constructor(props){
    super(props);

    this.state = {
      username: '',
      password: '',
      messageShown: true,
      messageTimer: null,
      language: {},
      languages: [],
      translations: {},
      message:  ''
    }
  }

  dismissMessage = () => {
    this.setState({
      messageShown: false
    })
  }

  showMessage = () => {
    clearTimeout(this.state.messageTimer);
    this.state.messageTimer = setTimeout(() => {
      this.dismissMessage();
    }, 6000);

    if (this.state.messageShown && this.props.loginFailure) {
      return <Toastr messageBody={this.state.message} messageType="error" dismiss={ this.dismissMessage.bind(this) }/>
    }
    return null;
  }

  componentWillMount = () => {
    this.props.getTranslations('English');
  }

  //Set the messageShown state to TRUE before the props are updated
  componentWillReceiveProps = (nextProps) => {
    const { language, languages } = nextProps;

    if (!language) return;

    const { translations={} } = language;
    const { invalid_credentials } = translations;

    this.setState({
      messageShown: true,
      language,
      languages,
      translations,
      message: invalid_credentials
    })
  }

  render(props) {
    const { login_description, email_placeholder, password_placeholder, login_button_text, forgot_password_link } = this.state.translations

    const loginTip = toolTipManager.getById(LOGIN_TOOL_TIP_ID);
    const resetTip = toolTipManager.getById(RESET_PASSWORD_TOOL_TIP_ID);
    const { features } = this.props.instanceConfig || {};

    return (
      <div>
        <SystemHeader
          showLanguage={false}
        />
        <div className='login-form'>
          { this.props.loginFailure && this.showMessage() }
          <Grid
            textAlign='center'
            style={{ height: '100%' }}
            verticalAlign='middle'
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='teal' textAlign='center'>
                <div className='login-header-content'>
                  {login_description}
                  { features && features.tool_tips && loginTip && (
                    <ToolTip
                      title={loginTip.title}
                      description={loginTip.description}
                      video={loginTip.video_link}
                      size='small'
                    />
                  )}
                </div>
              </Header>
              <Form size='large'>
                <Segment>
                  <Form.Input
                    fluid
                    icon='user'
                    iconPosition='left'
                    placeholder={email_placeholder}
                    type='username'
                    onChange={event => this.setState({username: event.target.value})}
                  />
                  <Form.Input
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder={password_placeholder}
                    type='password'
                    onChange={event => this.setState({password: event.target.value})}
                  />
                  <Button loading={this.props.pending} color='teal' fluid size='large' onClick={() => this.props.login(this.state)}>{login_button_text}</Button>
                    <div className='login-forgot-password-content'>
                      <Link to='/password_reset'>
                        {forgot_password_link}
                      </Link>
                      { features && features.tool_tips && resetTip && (
                        <ToolTip
                          title={resetTip.title}
                          description={resetTip.description}
                          video={resetTip.video_link}
                          size='mini'
                        />
                      )}
                    </div>
                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    loading: state.app_token.loading,
    loginSuccess: state.app_token.loginSuccess,
    loginFailure: state.app_token.loginFailure,
    pending: state.app_token.pending,
    signedIn: state.app_token.signedIn,
    language: state.language.language,
    languages: state.language.languages,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (localState) => {
      var { username, password, grant_type } = localState;
      dispatch(fetchAppToken({username, password, grant_type }))
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
  }
}

let LoginPage = connect(mapStateToProps, mapDispatchToProps)(Login)
export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/login.js